export default __webpack_public_path__ + "static/media/lock_icon.e8f8f72a.svg";